// extracted by mini-css-extract-plugin
export var completionBody = "_kd-2";
export var completionCard = "_kd-0";
export var completionFooter = "_kd-3";
export var completionTitle = "_kd-1";